import React, { useState, useEffect } from 'react';
import { FormGroup, Button, Grid, Typography, Box } from '@mui/material';
import '../../../../../styles/sass/global/components/checker.scss';
import { palette } from '../../../../../styles/theme';

export default function FilterRow ({ filter, filtersList, selectFilter, handleAddFilter, handleRemoveFilter, handleFilterInput, typesToFilter, propertiesToFilter, marginTopProps }) {
    const urlFilter = filtersList[0].value !== '' ? selectFilter?.value : '';

    // State
    const [property, setProperty] = useState(filter.property);
    // eslint-disable-next-line no-unused-vars
    const [value, setValue] = useState(filter.value);
    const [initialized, setInitialized] = useState(false);
    const [selectedFilters, setSelectedFilters] = useState(urlFilter);

    useEffect(() => {
        setSelectedFilters(urlFilter);
    }, [urlFilter]);
    // Handlers

    const handleSelectProp = (value, id) => {
        const cleanValue = '';

        if (value === null) {
            const cleanProperty = { type: 'text', label: '' };
            setProperty(cleanProperty);
            setValue(cleanValue);
            // clean filters setFilter
            handleFilterInput(cleanProperty, cleanValue, id);
            return undefined;
        }

        setProperty(value);
        setValue(cleanValue);
    };

    const handleValue = (value, id, prop) => {
        setSelectedFilters(value);

        chargeFilterProperty(prop);
        setValue(value);
        let idFilter = id;
        if (filtersList[0].value === '') {
            idFilter = 0;
        }
        else {
            idFilter = filtersList.length;
        }

        handleFilterInput(prop, value, idFilter);
    };

    // eslint-disable-next-line no-unused-vars
    const getListOfFilter = () => {
        // if we find the filter that was selected return typesToFilter available or any filter was selected
        if (typesToFilter.filter(filter => filter.id === property.id).length || !property.id?.toString()) {
            return typesToFilter;
        }
        // if we don't find the filter that was selected return propertiesToFilter
        return propertiesToFilter.filter(filter => filter.id === property.id);
    };

    const chargeFilterProperty = (oneValue) => {
        if (!initialized) {
            // const oneValue = getListOfFilter()[0].value;
            handleSelectProp(oneValue);
            setInitialized(true);
        }
    };

    // Main Component

    return (
        <Grid container spacing={2} key={filter.id} className='grid' style={{ marginTop: marginTopProps || '15px' }}>
            <Grid item xs={5}>
                <FormGroup>
                    <Typography variant='filterTitle'>{filter.label}</Typography>
                </FormGroup>
            </Grid>
            <Grid style={{ marginTop: '10px' }}>
                <FormGroup>
                    <Box style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', marginLeft: '13px' }}>
                        {
                            filter?.value?.data?.map(item => {
                                return (<Button
                                    key={item.value.id}
                                    variant={selectedFilters === item.value ? 'contained' : 'outlined'}
                                    className='button_radio--option'
                                    style={{
                                        backgroundColor: selectedFilters === item.value ? palette.secondary[600] : 'white',
                                        color: selectedFilters === item.value ? 'white' : palette.secondary[600],
                                    }}
                                    onClick={() => { handleValue(item.value, filter.id, filter.value); }}
                                >
                                    {item.label}
                                </Button>);
                            })
                        }
                    </Box>
                </FormGroup>
            </Grid>
        </Grid>
    );
}
